import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import { GridService } from '@core/services';

@Component({
  selector: 'z-legend-entry',
  templateUrl: './legend-entry.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendEntryComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  @Input() label: string;
  @Input() title: string = null;
  @Input() color:
    | 'grey'
    | 'blue'
    | 'green'
    | 'yellow'
    | 'cyan'
    | 'pink'
    | 'indigo'
    | 'teal'
    | 'orange'
    | 'blue-gray'
    | 'purple'
    | 'red'
    | 'light-blue'
    | 'light-green'
    | 'light-orange'
    | 'light-purple'
    | 'white'
    | 'none';

  @Input() styleClass: string = '';
  @Input() style: any = null;

  legendColor$ = new BehaviorSubject<string>(null);

  constructor(public gridService: GridService) {}

  ngOnInit() {
    if (!this.title || this.title === this.label) {
      this.title = this.label;
    } else {
      this.title = `<b>${this.label}</b><br />${this.title}`;
    }

    this.legendColor$.next(`legend-entry-${this.color} ${this.styleClass}`);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
